import { render, staticRenderFns } from "./supervise.vue?vue&type=template&id=5d21d56c&scoped=true&"
import script from "./supervise.vue?vue&type=script&lang=js&"
export * from "./supervise.vue?vue&type=script&lang=js&"
import style0 from "./supervise.vue?vue&type=style&index=0&id=5d21d56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21d56c",
  null
  
)

export default component.exports